import useResourceList from './useResourceList';
import mutationFactory from './mutationFactory';
import useQuery from './useQuery';
import { parseApiError } from './utils';

import api from '..';

export const useEmailsList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'emails', api: api.emails }, queryVariables, queryConfig);

  return {
    emails: queryResult.resolvedData,
    latestEmails: queryResult.latestData,
    ...queryResult,
  };
};

export const useEmailsByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['emails', { ids }], api.emails.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    emails: queryResult.data || [],
    ...queryResult,
  };
};

export const useEmail = (id, queryConfig = {}) => {
  const queryResult = useQuery(['email', { id }], api.emails.getById, {
    ...queryConfig,
    enabled: id,
  });

  return {
    email: queryResult.data || [],
    ...queryResult,
  };
};

const createMutation = mutationFactory({
  invalidate: 'emails',
  parseApiError: async (...args) => {
    const parsedError = await parseApiError(...args);

    if (typeof parsedError.json === 'string') {
      parsedError.message = parsedError.json;
    }

    return parsedError;
  },
});

export const useDeleteEmail = createMutation(api.emails.remove);

export const useCreateEmail = createMutation(api.emails.create);

export const useUpdateEmail = createMutation(api.emails.update);

export const useSendEmail = createMutation(api.emails.send);

export const useDuplicateEmail = createMutation(api.emails.duplicate);

export const useSendTestEmail = createMutation(api.emails.test);
